import { ApolloLogo } from '@jouzen/ecom-components/icons/ApolloLogo';
import { ClueLogo } from '@jouzen/ecom-components/icons/ClueLogo';
import { CronometerLogo } from '@jouzen/ecom-components/icons/CronometerLogo';
import { HeadspaceLogo } from '@jouzen/ecom-components/icons/HeadspaceLogo';
import { NaturalCyclesLogo } from '@jouzen/ecom-components/icons/NaturalCyclesLogo';
import { NoomLogo } from '@jouzen/ecom-components/icons/NoomLogo';
import { StravaLogo } from '@jouzen/ecom-components/icons/StravaLogo';
import { TalkspaceLogo } from '@jouzen/ecom-components/icons/TalkspaceLogo';
import { ThriveGlobalLogo } from '@jouzen/ecom-components/icons/ThriveGlobalLogo';
import { WildLogo } from '@jouzen/ecom-components/icons/WildLogo';
import { ZeroLogo } from '@jouzen/ecom-components/icons/ZeroLogo';
import type { MessageKey } from 'types/LocaleMessageKey';
import type { SVGIconComponent } from 'types/svgr';

import type { LandingPageIntegrationData } from '@/app/components/LandingPage/LandingPageIntegrations/types';

const tabCategories = [
  'womens_health_tag',
  'fitness_tag',
  'partnerships_behavioral_health',
  'partnerships_metabolic_health',
] as const;

type PartnershipIntegrationCategories = Extract<
  MessageKey,
  (typeof tabCategories)[number]
>;

export const partnershipIntegrationTabs: Record<
  PartnershipIntegrationCategories,
  LandingPageIntegrationData[]
> = {
  womens_health_tag: [
    {
      description: 'partnerships_natural_cycles',
      Logo: NaturalCyclesLogo as SVGIconComponent,
      name: 'NaturalCycles',
    },
    {
      description: 'partnerships_clue',
      Logo: ClueLogo as SVGIconComponent,
      name: 'Clue',
    },
  ],
  fitness_tag: [
    {
      description: 'partnerships_strava',
      Logo: StravaLogo as SVGIconComponent,
      name: 'Strava',
    },
    {
      description: 'partnerships_wild',
      Logo: WildLogo as SVGIconComponent,
      logoClassName: 'h-14 mt-[-8px] mb-2.5',
      name: 'Wild',
    },
  ],
  partnerships_behavioral_health: [
    {
      description: 'partnerships_headspace',
      Logo: HeadspaceLogo as SVGIconComponent,
      name: 'Headspace',
    },
    {
      description: 'partnerships_integrations_thrive_global_copy',
      Logo: ThriveGlobalLogo as SVGIconComponent,
      name: 'Thrive Global',
    },
    {
      description: 'partnerships_integrations_talkspace_copy',
      Logo: TalkspaceLogo as SVGIconComponent,
      logoClassName: 'w-40 xl:w-48',
      name: 'Talkspace',
    },
    {
      description: 'partnerships_apollo',
      Logo: ApolloLogo as SVGIconComponent,
      name: 'Apollo',
    },
  ],
  partnerships_metabolic_health: [
    {
      description: 'partnerships_noom',
      Logo: NoomLogo as SVGIconComponent,
      name: 'Noom',
    },
    {
      description: 'partnerships_zero',
      Logo: ZeroLogo as SVGIconComponent,
      name: 'Apollo',
    },
    {
      description: 'partnerships_cronometer',
      Logo: CronometerLogo as SVGIconComponent,
      name: 'Cronometer',
    },
  ],
};
